import { useState, FC } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { StoreGrid, StoreGridPluginSettings } from ".";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { useTranslation } from "react-i18next";

const StoreSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntities ?? [])
    const [focusTaken, setFocusTaken] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(false)
    const [multipleSelect, setMultipleSelect] = useState<boolean>(props.multipleSelect ?? false);
    const gridId = uuidv4();
    const plugin = StoreGridPluginSettings;
    const { t } = useTranslation();

    const checkMultipleSelect: boolean = multipleSelect 
        ? (entities.length > 0 ? false : true) 
        : (Object.keys(entity).length > 0 ? false : true);

    return (
        <GridSelectorModalWindow
            entityToPressEnter={entity}
            fullScreen
            gridDisplayName={plugin?.name ?? t('directory.stores.typeofStore')}
            focusTaken={focusTaken}
            ok={{
                onClick: () => multipleSelect ? props.ok(entities) : props.ok?.(entity),
                disabled: disabled || props.dataFromPluginGridSelectorInput ? false : checkMultipleSelect
            }}
            cancel={{
                onClick: () => props.cancel?.()
            }}
            style={props.style} >
            {
                plugin
                    ? <StoreGrid
                        showGroupProcessing={props.showGroupProcessing}
                        data={entities}
                        gridId={gridId}
                        plugin={plugin}                        
                        idTable={props.idTable}
                        isEnabledTo={props.isEnabledTo}
                        multipleSelect={multipleSelect}
                        setMultipleSelect={setMultipleSelect}
                        baseGridFilter={props.gridFilter}
                        isModal
                        permission={props.permission}
                        applyUserFilter={props.applyUserFilter}
                        documentType={props.documentType}
                        dataFromPluginGridSelectorInput={props.dataFromPluginGridSelectorInput}
                        isSearchForMultyselect={props.isSearchForMultyselect}
                        onFocusChanged={(taken: boolean) => {
                            setFocusTaken(taken);
                        }}
                        onSelect={(row, rowDto) => {
                            if (row && rowDto && rowDto.deleted === false) {
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                                setDisabled(false)
                            } else if (row && rowDto && rowDto.deleted === true) {
                                setDisabled(true)
                            } else if (row) {
                                setDisabled(false)
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            } else {
                                setDisabled(true)
                                setEntity({ idGlobal: '', displayName: '' })
                            }
                        }}
                        onMultipleSelect={(rows) => {
                            if (rows.length > 0) {
                                setDisabled(false)
                                setEntities(rows.map(x => ({ idGlobal: x.idGlobal, displayName: x.displayName } as IEntitySimpleDTO)))
                            } else {
                                setDisabled(true)
                                setEntities([])
                            }
                        }}
                        onDoubleClick={(row, rowDto) => {
                            if (row && rowDto && rowDto.deleted === false) {
                                setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                                props.ok?.({ idGlobal: row.idGlobal, displayName: row.displayName })
                            }
                        }}
                    />
                    : <p> {t('general.directoryNotConfigured')} </p>
            }
        </GridSelectorModalWindow>
    )
}

export default StoreSelectorModal